function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.8261 0H1.3913C0.626087 0 0 0.626087 0 1.3913V27.8261C0 28.5913 0.626087 29.2174 1.3913 29.2174H27.8261C28.5913 29.2174 29.2174 28.5913 29.2174 27.8261V1.3913C29.2174 0.626087 28.5913 0 27.8261 0ZM23.3043 23.3043H5.91304V5.91304H23.3043V23.3043ZM62.6087 0H36.1739C35.4087 0 34.7826 0.626087 34.7826 1.3913V27.8261C34.7826 28.5913 35.4087 29.2174 36.1739 29.2174H62.6087C63.3739 29.2174 64 28.5913 64 27.8261V1.3913C64 0.626087 63.3739 0 62.6087 0ZM58.087 23.3043H40.6957V5.91304H58.087V23.3043ZM27.8261 34.7826H1.3913C0.626087 34.7826 0 35.4087 0 36.1739V62.6087C0 63.3739 0.626087 64 1.3913 64H27.8261C28.5913 64 29.2174 63.3739 29.2174 62.6087V36.1739C29.2174 35.4087 28.5913 34.7826 27.8261 34.7826ZM23.3043 58.087H5.91304V40.6957H23.3043V58.087ZM62.6087 34.7826H36.1739C35.4087 34.7826 34.7826 35.4087 34.7826 36.1739V62.6087C34.7826 63.3739 35.4087 64 36.1739 64H62.6087C63.3739 64 64 63.3739 64 62.6087V36.1739C64 35.4087 63.3739 34.7826 62.6087 34.7826ZM58.087 58.087H40.6957V40.6957H58.087V58.087Z",
  fill: "#373F51"
});

var SvgCard = function SvgCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card.351d68dd.svg";
export { ForwardRef as ReactComponent };